import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import { PageHeader } from '@verantos-dev/shared-components';

import { ConceptGroupsGrid } from './components/ConceptGroupsGrid';

export const ConceptGroupsListPage = () => {
  const isCreateConceptGroupEnabled = useFeatureFlagSplit('create_concept_group_via_file_upload');
  const intl = useIntl();

  return (
    <Box data-testid="concept-groups-list-page">
      <PageHeader
        id="concept-groups-page-header"
        data-testid="concept-groups-page-header"
        pageTitle={intl.formatMessage({ id: 'conceptGroups.pageTitle' })}
        actions={
          isCreateConceptGroupEnabled
            ? [
                {
                  id: 'create-concept-group',
                  label: intl.formatMessage({ id: 'conceptGroups.actions.createConceptGroup' }),
                  onClickHandler: () => {
                    // TODO: @chris.may - Implement create concept group handler
                  },
                  btnType: 'primary',
                  startIcon: 'add',
                },
              ]
            : undefined
        }
      />
      <ConceptGroupsGrid />
    </Box>
  );
};

export default ConceptGroupsListPage;
